import http from '@core/fetch'

export default {
  checkBind: () => http('/p/wedding/Admin/APIMerchantWeapp'),

  msgCode: body =>
    http.post('/p/wedding/index.php/Home/APIUser/send_msg', { body }),

  contact: body =>
    http.post('/p/wedding/Admin/APIMerchantWeapp/reg_contact', { body })
}
